import { memo } from 'react';
import CONFIG from 'src/utils/config';
import SparePartsBrekr from './SparePartsBrekr';
import SparePartsPage from './SparePartsPage';
import { AppBrands } from 'src/utils/constants';

export const SparePartsPageWrapper = memo(() => {
    const brand = CONFIG.APP_BRAND;

    if (brand === AppBrands.BREKR) {
        return <SparePartsBrekr />;
    }

    return <SparePartsPage />;
});
